import { Button } from '@xefi/x-react/button';
import { useRouter } from 'next/navigation';
import { useTranslation } from 'react-i18next';

export const SurveyTakingError = () => {
   const { t } = useTranslation();
   const router = useRouter();

   return (
      <div className='bg-content1-100 flex h-dvh justify-center px-10 py-4'>
         <div className='dark:bg-background flex h-[calc(100vh-2rem)] w-full max-w-5xl rounded-lg bg-white'>
            <div className='flex h-full w-full flex-col items-center justify-center gap-6 overflow-y-auto px-10 py-6'>
               <p className='text-sm'>{t('survey.noSurvey')}</p>
               <Button
                  onClick={() => {
                     router.push('/');
                  }}
               >
                  {t('home.back')}
               </Button>
            </div>
         </div>
      </div>
   );
};
